import React, { Component } from "react";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
            userDescription: "",
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error);
        this.setState({ error, errorInfo });
    }

    handleDescriptionChange = (event) => {
        this.setState({ userDescription: event.target.value });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { error, errorInfo, userDescription } = this.state;

        // Log or send feedback to your error reporting service
        console.log("User description:", userDescription);
        console.log("Error:", error);
        console.log("Error info:", errorInfo);

        alert("Thank you for your feedback. We will look into the issue.");
        this.setState({ hasError: false }); // Optional: reset error state
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
                    <h2>Something went wrong</h2>
                    <p>We're sorry, but an unexpected error occurred. Please provide any details that might help us resolve the issue.</p>
                    <form onSubmit={this.handleSubmit}>
                        <div>
                            <strong>Error Details:</strong>
                            <pre style={{ background: '#f8f8f8', padding: '10px', borderRadius: '5px', overflowX: 'auto' }}>
                                {this.state.error && this.state.error.toString()}
                            </pre>
                        </div>
                        <div>
                            <textarea
                                value={this.state.userDescription}
                                onChange={this.handleDescriptionChange}
                                placeholder="Describe what you were doing when the error occurred..."
                                style={{
                                    width: '100%',
                                    height: '100px',
                                    marginTop: '10px',
                                    padding: '10px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                }}
                            />
                        </div>
                        <button
                            type="submit"
                            style={{
                                marginTop: '10px',
                                padding: '10px 20px',
                                backgroundColor: '#007bff',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                            }}
                        >
                            Submit Feedback
                        </button>
                    </form>
                </div>
            );
        }

        return this.props.children;
    }
}


export default ErrorBoundary;
